import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { WineRegion } from './interfaces/region';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private countriesUrl = './assets/countries.json';


  constructor(private http: HttpClient) { }

  getCountries(): Observable<any> {
    return this.http.get<any>(this.countriesUrl);
  }

  getWineRegion(companyId?: string): Observable<WineRegion[]> {
    // Crea un array con 6 oggetti `WineRegion`
    const wineRegions: WineRegion[] = [
      {
        id: 1,
        name: 'Chianti Classico',
        discoverText: 'Nel cuore della Toscana',
        headerImg: {
          src: 'https://res.cloudinary.com/divinea/image/upload/v1/production/cache/lgdkpct7hn0skbfbupgi.jpg',
          alt: 'toscana regione vinicola'
        },
        numExperiences: 152
      },
      {
        id: 2,
        name: 'Barolo',
        discoverText: 'Nel cuore del Piemonte',
        headerImg: {
          src: 'https://cdn.pixabay.com/photo/2014/08/26/15/17/vineyard-428041_1280.jpg',
          alt: 'barolo regione vinicola'
        },
        numExperiences: 100
      },
      {
        id: 3,
        name: 'Montalcino',
        discoverText: 'Toscana famosa per il Brunello',
        headerImg: {
          src: 'https://cdn.pixabay.com/photo/2014/08/26/15/17/vineyard-428041_1280.jpg',
          alt: 'montalcino regione vinicola'
        },
        numExperiences: 80
      },
      {
        id: 4,
        name: 'Langhe',
        discoverText: 'Nel cuore del Piemonte',
        headerImg: {
          src: 'https://cdn.pixabay.com/photo/2014/08/26/15/17/vineyard-428041_1280.jpg',
          alt: 'napa valley regione vinicola'
        },
        numExperiences: 200
      },
      {
        id: 5,
        name: 'Oltrepò Pavese',
        discoverText: 'Famoso per il suo vino rosso',
        headerImg: {
          src: 'https://cdn.pixabay.com/photo/2014/08/26/15/17/vineyard-428041_1280.jpg',
          alt: 'bordeaux regione vinicola'
        },
        numExperiences: 250
      },
      {
        id: 6,
        name: 'Prosecco',
        discoverText: 'Vino frizzante della zona veneta',
        headerImg: {
          src: 'https://cdn.pixabay.com/photo/2014/08/26/15/17/vineyard-428041_1280.jpg',
          alt: 'prosecco regione vinicola'
        },
        numExperiences: 300
      }
    ];

    // Restituisci l'array di regioni vinicole
    return of(wineRegions);
  }




}
